"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticsService = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("../types");
var StatisticsService = /** @class */ (function () {
    function StatisticsService() {
    }
    StatisticsService.prototype.generate = function (uploaded, stats) {
        var today = new Date();
        var now = today.getTime();
        var clickInfo = {
            ts: now,
            successReportCount: 0,
            successEventType: types_1.EventType.Click,
        };
        var exposeInfo = {
            ts: now,
            successReportCount: 0,
            successEventType: types_1.EventType.Expose,
        };
        var inputInfo = {
            ts: now,
            successReportCount: 0,
            successEventType: types_1.EventType.Input,
        };
        var viewInfo = {
            ts: now,
            successReportCount: 0,
            successEventType: types_1.EventType.View,
        };
        // 还没有统计事件的数据，新增一个
        stats = stats || {
            eventType: types_1.EventType.Statistics,
            offset: 0,
            extraInfo: {},
            statisticsList: [clickInfo, exposeInfo, inputInfo, viewInfo],
        };
        for (var i = 0; i < uploaded.length; i++) {
            var eventType = uploaded[i].eventType;
            switch (eventType) {
                case types_1.EventType.Click:
                    stats.statisticsList[0].successReportCount += 1;
                    break;
                case types_1.EventType.Expose:
                    stats.statisticsList[1].successReportCount += 1;
                    break;
                case types_1.EventType.Input:
                    stats.statisticsList[2].successReportCount += 1;
                    break;
                case types_1.EventType.View:
                    stats.statisticsList[3].successReportCount += 1;
                    break;
                default:
                    break;
            }
        }
        return stats;
    };
    StatisticsService.prototype.dispatchData = function (records) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.saveLogsService.dispatch({
                                            list: records,
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StatisticsService.prototype.addRecord = function (uploaded) {
        return __awaiter(this, void 0, void 0, function () {
            var newRecord;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newRecord = this.generate(uploaded);
                        return [4 /*yield*/, this.dispatchData([newRecord])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StatisticsService.prototype.updateRecords = function (records) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dispatchData(records)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StatisticsService.prototype.handleStatisticsExist = function (uploaded, existRecords) {
        return __awaiter(this, void 0, void 0, function () {
            var today, todayDate, latestTS, i, record, latestDate, i, record, index, updated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        today = new Date();
                        todayDate = today.getDate();
                        latestTS = 0;
                        // 找到最新的统计事件记录时间
                        for (i = 0; i < existRecords.length; i++) {
                            record = existRecords[i];
                            if (record.ts > latestTS) {
                                latestTS = record.ts;
                            }
                        }
                        latestDate = new Date(latestTS).getDate();
                        if (!(latestDate > todayDate)) return [3 /*break*/, 3];
                        // 不是同一天，将已有的数据置为已完备，准备上报，并增加新数据
                        for (i = 0; i < existRecords.length; i++) {
                            record = existRecords[i];
                            record.isComplete = true;
                        }
                        return [4 /*yield*/, this.updateRecords(existRecords)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.addRecord(uploaded)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 3:
                        index = existRecords.findIndex(function (r) { return !r.isComplete; });
                        if (!(index === -1)) return [3 /*break*/, 5];
                        // 同一天的都上报过了，生成新数据
                        return [4 /*yield*/, this.addRecord(uploaded)];
                    case 4:
                        // 同一天的都上报过了，生成新数据
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        updated = this.generate(uploaded, existRecords[index]);
                        existRecords[index] = updated;
                        return [4 /*yield*/, this.updateRecords(existRecords)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    StatisticsService.prototype.addOrUpdate = function (uploaded) {
        return __awaiter(this, void 0, void 0, function () {
            var existRecords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!uploaded.length) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.logDataStore.queryByCondition(function (r) { return r.eventType === types_1.EventType.Statistics; })];
                    case 1:
                        existRecords = _a.sent();
                        if (!existRecords.length) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.handleStatisticsExist(uploaded, existRecords)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.addRecord(uploaded)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.ILogDataStore),
        __metadata("design:type", Object)
    ], StatisticsService.prototype, "logDataStore", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IDispatchLogsService),
        (0, inversify_1.named)(types_1.TAG.SaveLogsService),
        __metadata("design:type", Object)
    ], StatisticsService.prototype, "saveLogsService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IApplicationExecutor),
        __metadata("design:type", Object)
    ], StatisticsService.prototype, "applicationExecutor", void 0);
    StatisticsService = __decorate([
        (0, inversify_1.injectable)()
    ], StatisticsService);
    return StatisticsService;
}());
exports.StatisticsService = StatisticsService;
